<div class="login-auth-content">
  <div class="background-overlay"></div>
  
  <div class="login-wrapper">
    <div class="header-section animate__animated animate__fadeInDown">
      <a routerLink="/home">
        <img
          class="logo-auth"
          src="assets/img/logo-signomedico-1.png"
          alt="Logo Signo Médico"
        />
      </a>
      <h2 class="slogan-auth">Bienvenido a Signo Médico</h2>
    </div>

    <div class="auth-container animate__animated animate__fadeInUp">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
